import { render } from "./BtnDetalhar.vue?vue&type=template&id=5188105f"
import script from "./BtnDetalhar.vue?vue&type=script&lang=js"
export * from "./BtnDetalhar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__